module.exports = __webpack_public_path__ + "img/MD.ffacb7fd.svg";